import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import store from "../../../../store";
import * as actions from "../../../../actions/actionFunctions";
import UserLoginButton from "../../../ui/userLoginButton";

import {ContentType} from "../../constants";
import Analytics from "../../../../analytics";
import HomeMenu from "../../../common/homeMenu";
import ScheduleButton from "../../../common/scheduleButton";
import Config from "../../../../config";
import {getShowOtherLayouts} from "../navUtils";

class MobileNavigationButtons extends Component {

  static propTypes = {
    handleChangeContentType: PropTypes.func.isRequired,
    handleSearchInputChange: PropTypes.func.isRequired,
    resetEverything: PropTypes.func.isRequired,
    contentType: PropTypes.number.isRequired,
    searchText: PropTypes.string,
    parentNavigationItem: PropTypes.object,
    canvasId: PropTypes.string,
    userIsLoggedIn: PropTypes.bool,
    toggleUserPopup: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      designNavigationOpened: ''
    }
  }

  handleDropDownButtonClick = (type) => {
    Analytics.sendClickEvent('mobile-' + type + '-button-clicked');
    this.setState({
      designNavigationOpened: this.state.designNavigationOpened === type ? '' : type
    }, () => {
      this.state.designNavigationOpened
        ? window.addEventListener('click', this.handleDropdownWrapperBlur)
        : window.removeEventListener('click', this.handleDropdownWrapperBlur)
    })
  };

  handleResetButtonClick = () => {
    Analytics.sendClickEvent("mobile-nav-reset-button-question");
    this.props.changeMessageBoxState({
      visible: true,
      message: "messageBox.resetVisualizerState",
      buttons: [{
        text: "messageBox.buttonNo",
        color: "blue",
        click: () => {
          Analytics.sendClickEvent("mobile-nav-reset-button-no");
          this.props.changeMessageBoxState({visible:false});
        }
      },{
        text: "messageBox.buttonYes",
        color: "green",
        click: () => {
          Analytics.sendClickEvent("mobile-nav-reset-button-yes");
          this.props.changeMessageBoxState({visible:false});
          setTimeout(() => {
            this.setState({
              designNavigationOpened: ''
            });
            this.props.resetEverything();
          }, 500);
        }
      }]
    });
  };

  changeContentType = (contentType) => {
    this.props.handleChangeContentType(contentType);
    this.resetDropDown();
  };

  resetDropDown = () => {
    this.setState({
      designNavigationOpened: ''
    }, () => {
      window.removeEventListener('click', this.handleDropdownWrapperBlur)
    })
  };

  handleDisplayRoomClick = () => {
    Analytics.sendClickEvent('mobile-navigation-display-room-button');
    this.changeContentType(ContentType.DisplayRoom);
    this.resetDropDown();
  };

  handleDropdownWrapperBlur = (e) => {
    const newButtonClick = e.target.closest('.menu-header__right-button');
    const dropDownClick = e.target.closest('[class*="menu-dropdown"]');
    const userPopupClick = e.target.closest('[class*="user-popup"]');
    if (!newButtonClick && !dropDownClick && !userPopupClick) {
      this.resetDropDown();
    }
  };

  handleFiltersClick = () => {
    Analytics.sendClickEvent('mobile-show-filters');
    store.dispatch(actions.showFiltersIfHidden('mobileNavigation'));
  };

  render() {
    const {intl} = this.props;
    const dashboardFramed = Config.isVisualizerManagement();
    const fabricatorSettings = this.props.fabricatorSettings;
    let showOtherLayouts = getShowOtherLayouts(fabricatorSettings);

    return (
      <div className="menu-header__right">
        {this.props.mobileNav.length && this.props.windowWidth < 991 ? (
          <HomeMenu/>
        ) : null}
        {this.props.parentNavigationItem ? (
          <button className="menu-header__right-button menu-header__right-button--filters"
                  onClick={this.handleFiltersClick}>
            <span className="menu-header__right-button-text"><FormattedMessage id="mobileMenu.filtersButton"/></span>
            {this.props.selectedFilters.length ?
              <span className="materials-button--cart-length bold">{this.props.selectedFilters.length}</span> : null
            }
          </button>
        ) : null}
        {/*this.props.parentNavigationItem ? (
          <button className={"menu-header__right-button menu-header__right-button--search"
          + (this.state.designNavigationOpened === 'search' ? " menu-header__right-button--active" : "")}
                  onClick={() => this.handleDropDownButtonClick('search')}>
            <span className="menu-header__right-button-text">search</span>
          </button>
        ) : null*/}
        {dashboardFramed ? null : <UserLoginButton />}
        <button className={"menu-header__right-button"
        + (this.props.contentType === ContentType.Design
          ? " menu-header__right-button--design" : " menu-header__right-button--layout")
        + (this.state.designNavigationOpened === 'menu' ? " menu-header__right-button--active" : "")}
                onClick={() => this.handleDropDownButtonClick('menu')}>
          <span className="menu-header__right-button-text">
            <FormattedMessage id={this.props.contentType === ContentType.Design
              ? "mobileMenu.designButton"
              : this.props.contentType === ContentType.Layout ? "mobileMenu.layoutButton" : "mobileMenu.designMenuRooms"}/>
          </span>
        </button>
        <div className={"menu-dropdown"
        + (this.state.designNavigationOpened ? ` menu-dropdown--opened-${this.state.designNavigationOpened}` : "")
        + (this.state.designNavigationOpened && showOtherLayouts ? ` menu-dropdown--with-layout` : "")
        + (this.state.designNavigationOpened && fabricatorSettings.enableScheduling ? ` menu-dropdown--with-schedule` : "")}>
          {this.state.designNavigationOpened === 'menu' ? (
            <ul className="menu-dropdown__list">
              <li className="menu-dropdown__list-item menu-dropdown__list-item--design"
                  onClick={() => Analytics.sendClickEvent('menu-option-clicked-design') && this.changeContentType(ContentType.Design)}>
                <FormattedMessage id="mobileMenu.designButton"/>
              </li>
              <li className="menu-dropdown__list-item menu-dropdown__list-item--room" onClick={this.handleDisplayRoomClick}>
                <FormattedMessage id="mobileMenu.displayRoomButton"/>
              </li>
              {/*<li className="menu-dropdown__list-item menu-dropdown__list-item--quoted" onClick={this.resetDropDown}>Quoted Items</li>*/}
              {showOtherLayouts ? (
                <li className="menu-dropdown__list-item menu-dropdown__list-item--layout"
                    onClick={() => Analytics.sendClickEvent('menu-option-clicked-roomLayout') && this.changeContentType(ContentType.Layout)}>
                  <FormattedMessage id="mobileMenu.designMenuLayout"/>
                </li>
              ) : null}
              <li className="menu-dropdown__list-item menu-dropdown__list-item--reset"
                  onClick={this.handleResetButtonClick}><FormattedMessage id="mobileMenu.designMenuReset"/></li>
              <ScheduleButton buttonLayoutId={"mobileNavigationMenu"}/>
            </ul>
          ) : null}
          {this.state.designNavigationOpened === 'search' ? (
            <div className="menu-dropdown__search">
              <input className={"menu-dropdown__search-input"
              + (this.state.searchText ? " menu-dropdown__search--no-icon" : "")}
                     value={this.props.searchText} type="text"
                     onChange={this.props.handleSearchInputChange}
                     placeholder={intl.formatMessage({id: "mobileMenu.searchPlaceholder"})}/>
              {this.props.searchText ? (
                <button className="menu-dropdown__search-reset" onClick={() => {
                  Analytics.sendClickEvent('search-reset');
                  this.props.handleSearchInputChange({target:{value:""}})
                }}/>
              ) : null}
            </div>
          ) : null}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  mobileNav: store.navigationState.mobileNav,
  windowWidth: store.serverState.windowWidth,
  fabricatorSettings: store.fabricatorState.settings,
  selectedFilters: store.filterState.selectedFilters,
});

const mapDispatchToProps = {};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(MobileNavigationButtons)
)
